import type { ReactNode } from 'react';

/** Inline social / share icons (no icon package dependency). */

type IconProps = { size?: number; className?: string };

function Svg({
  size = 16,
  className,
  children,
  label,
}: IconProps & { children: ReactNode; label: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden
      className={className}
      focusable="false"
    >
      <title>{label}</title>
      {children}
    </svg>
  );
}

export function IconX({ size, className }: IconProps) {
  return (
    <Svg size={size} className={className} label="X">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.74l7.727-8.835L1.254 2.25H8.08l4.253 5.622L18.244 2.25zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77z" />
    </Svg>
  );
}

export function IconFacebook({ size, className }: IconProps) {
  return (
    <Svg size={size} className={className} label="Facebook">
      <path d="M22 12.07C22 6.48 17.52 2 11.93 2S1.86 6.48 1.86 12.07c0 4.99 3.66 9.13 8.44 9.93v-7.03H7.9v-2.9h2.4V9.84c0-2.37 1.41-3.68 3.56-3.68 1.03 0 2.11.18 2.11.18v2.32h-1.19c-1.17 0-1.54.73-1.54 1.48v1.78h2.62l-.42 2.9h-2.2V22c4.78-.8 8.44-4.94 8.44-9.93z" />
    </Svg>
  );
}

export function IconLinkedIn({ size, className }: IconProps) {
  return (
    <Svg size={size} className={className} label="LinkedIn">
      <path d="M4.98 3.5C4.98 4.88 3.86 6 2.5 6S.02 4.88.02 3.5 1.14 1 2.5 1s2.48 1.12 2.48 2.5zM.14 8.14h4.72V23H.14V8.14zM8.34 8.14h4.52v2.02h.06c.63-1.2 2.17-2.46 4.47-2.46 4.78 0 5.66 3.14 5.66 7.23V23h-4.72v-6.63c0-1.58-.03-3.61-2.2-3.61-2.2 0-2.54 1.72-2.54 3.5V23H8.34V8.14z" />
    </Svg>
  );
}

export function IconLink({ size, className }: IconProps) {
  return (
    <Svg size={size} className={className} label="Copy link">
      <path d="M10.59 13.41a1.75 1.75 0 0 0 2.47 0l3.18-3.18a1.75 1.75 0 1 0-2.47-2.47l-.88.88a.75.75 0 0 1-1.06-1.06l.88-.88a3.25 3.25 0 1 1 4.6 4.6l-3.18 3.18a3.25 3.25 0 0 1-4.6 0 .75.75 0 0 1 1.06-1.07z" />
      <path d="M13.41 10.59a1.75 1.75 0 0 0-2.47 0L7.76 13.77a1.75 1.75 0 1 0 2.47 2.47l.88-.88a.75.75 0 1 1 1.06 1.06l-.88.88a3.25 3.25 0 1 1-4.6-4.6l3.18-3.18a3.25 3.25 0 0 1 4.6 0 .75.75 0 0 1-1.06 1.07z" />
    </Svg>
  );
}

export function IconPinterest({ size, className }: IconProps) {
  return (
    <Svg size={size} className={className} label="Pinterest">
      <path d="M12.04 2C6.5 2 3 5.78 3 10.36c0 2.86 1.6 4.54 2.5 4.54.37 0 .59-1.03.59-1.33 0-.35-.89-.1.1-2.32C5.2 8.4 6.84 5.1 12.18 5.1c7.4 0 6.42 6.66 4.5 9.9-1.4 2.37-4.14.8-3.56-1.42.4-1.5 1.16-3.12 1.16-4.2 0-1.93-2.76-1.64-2.76 2.37 0 1.64.55 2.75.55 2.75S11.3 18.9 10.9 20.6c-.7 2.94-.1 6.56-.05 6.92.03.2.28.26.38.1.16-.23 2.16-2.68 2.84-5.16.2-.7 1.1-4.3 1.1-4.3.54 1.03 2.13 1.94 3.82 1.94 5.02 0 8.42-4.57 8.42-10.7C27.41 5.3 20.7 2 12.04 2Z" transform="translate(-3 -2) scale(.85)" />
    </Svg>
  );
}

export function IconWhatsApp({ size, className }: IconProps) {
  return (
    <Svg size={size} className={className} label="WhatsApp">
      <path d="M12.04 2C6.5 2 2 6.36 2 11.72c0 1.72.46 3.4 1.33 4.88L2 22l5.58-1.46A10.2 10.2 0 0 0 12.04 21.5C17.58 21.5 22 17.14 22 11.78 22 6.36 17.58 2 12.04 2zm5.9 14.32c-.25.7-1.44 1.28-2.01 1.36-.52.07-1.18.1-1.9-.12-.44-.13-1-.32-1.72-.62-3.03-1.3-5-4.36-5.15-4.56-.15-.2-1.25-1.66-1.25-3.17 0-1.5.79-2.24 1.07-2.55.28-.3.61-.38.81-.38h.58c.19 0 .44-.07.69.52.25.62.86 2.1.93 2.25.08.15.12.33.02.53-.1.2-.15.33-.3.5-.15.18-.31.4-.44.53-.15.15-.3.31-.13.6.17.3.76 1.25 1.64 2.03 1.13 1 2.08 1.31 2.38 1.46.3.15.47.12.64-.07.18-.2.75-.87.95-1.17.2-.3.4-.25.67-.15.28.1 1.75.83 2.05.98.3.15.5.22.58.35.07.12.07.7-.18 1.4z" />
    </Svg>
  );
}

export function IconShare({ size, className }: IconProps) {
  return (
    <Svg size={size} className={className} label="Share">
      <path d="M18 8a3 3 0 1 0-2.83-4H15a3 3 0 0 0 .17 1H8.83A3.001 3.001 0 1 0 6 11c.35 0 .68-.06 1-.17v2.34A3.001 3.001 0 1 0 9.17 16H15.2a3 3 0 1 0 2.63-4.5 2.99 2.99 0 0 0-1.66.5v-2.17A3 3 0 0 0 18 8z" />
    </Svg>
  );
}
